import React, { useEffect, useMemo, useState, useCallback } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { isEmpty } from "lodash"
import "bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "../../../components/Common/TableContainer"
import * as Yup from "yup"
import { useFormik } from "formik"
import Select from "react-select"

//import components
import Breadcrumbs from "../../../components/Common/Breadcrumb"

import { Percentage, VendorType } from "./Budget_percentageListCol"

//redux
import { useSelector, useDispatch } from "react-redux"
import {
  addNewBudget_percentage,
  deleteBudget_percentage,
  getBudget_percentage,
  updateBudget_percentage,
} from "../../../store/budget-percentage/actions"
import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
  Spinner,
} from "reactstrap"
import DeleteModal from "../../../components/Common/DeleteModal"
import {CeremonyType} from './Budget_percentageListCol'
import { getVendor_cats } from "../../../store/vendor_cat/actions"
import { getCeremonies } from "../../../store/ceremony/actions"
import TableContainerBudget from "../../../components/Common/TableContainerBudget"
import { showPopup } from "../../../store/popup/actions"

function Budget_percentage() {
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)

  const [ceremony_pack, setCeremony] = useState([])
 const [selectedCeremony_type, setSelectedCeremonyType] = useState({})
  const [selectedVendor_type, setSelectedVendorType] = useState({})
  const [offset,setOffset]=useState(0)
  const [page_size, setPageSize] = useState(10)
  const budgets_percentage = useSelector(state => state.budget_percentage.data)
  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      budget_percentage: (ceremony_pack && ceremony_pack.budget_percentage) || "",
      is_active: (ceremony_pack && ceremony_pack.is_active) || 0,
    },

    validationSchema: Yup.object({
    }),

    onSubmit:async values => {
    
      if (isEdit) {
        const arr = budgets_percentage.filter(d=>d.ceremony_name ==  selectedCeremony_type.label && d.id != ceremony_pack.id)
        const sum = arr.reduce(
          (accumulator, a) => accumulator + parseInt(a.budget_percentage),
          0)
          if(parseInt(sum)+parseInt(values.budget_percentage) > 100){
            dispatch(showPopup({title:'Some of percentage for each ceremony should be 100%',warning:true}))
          }else{
            const UpdateCeremony = {
              id: ceremony_pack ? ceremony_pack.id : 0,
              ceremony_id: selectedCeremony_type.value,
              vendor_cat_id: selectedVendor_type.value,
              budget_percentage: values.budget_percentage,
              is_active: values["is_active"],
            }
    
            // update ceremony_pack
            dispatch(updateBudget_percentage(UpdateCeremony))
            dispatch(getBudget_percentage({is_active:1, offset,page_size}))
    
            validation.resetForm()

          }
       
      } else {
        const arr = budgets_percentage.filter(d=>d.ceremony_name ==  selectedCeremony_type.label)
        const sum = arr.reduce(
          (accumulator, a) => accumulator + parseInt(a.budget_percentage),
          0)
          if(parseInt(sum)+parseInt(values.budget_percentage) > 100){
            dispatch(showPopup({title:'Some of percentage for each ceremony should be 100%',warning:true}))
          }else{
        const newCeremony = {
          // id: Math.floor(Math.random() * (30 - 20)) + 20,
          ceremony_id: selectedCeremony_type.value,
          vendor_cat_id: selectedVendor_type.value,
          budget_percentage:values.budget_percentage,
          is_active: values["is_active"],
        }
        // save new ceremony_pack
        dispatch(addNewBudget_percentage(newCeremony))
        dispatch(getBudget_percentage({is_active:1, offset,page_size}))
        validation.resetForm()
      }
    }
      // toggle()
    },
  })

  const dispatch = useDispatch()

  const loading = useSelector(state => state.budget_percentage.loading)
  const ceremonies_type = useSelector(state => state.ceremony.ceremonies.ceremonies)
  const total_page = useSelector(
    state => state.budget_percentage.total_page
  )
  const vendors_type = useSelector(
    state => state.vendors.vendor_cats.vendor_cats
  )
  const ceremonies_typeOptions = ceremonies_type?.map(cer => {
    return { label: cer.name_en, value: cer.id }
  })
   const vendors_typeOptions = vendors_type?.map(cer => {
     return { label: cer.cat_name_en, value: cer.id }
   })
  
  function handleSelect(arg) {
    setSelectedCeremonyType(arg)
  }
  useEffect(() => {
   dispatch(getBudget_percentage({is_active:1, offset,page_size}))
    // dispatch(getCeremonies_pack())

    // }
  }, [dispatch, offset, page_size])
  useEffect(() => {
        dispatch(getVendor_cats({ is_active: 1 }))
        dispatch(getCeremonies({ is_active: 1, offset: "", page_size: "" }))
  },[dispatch])


  useEffect(() => {
    if (!isEmpty(budgets_percentage)) {
      setIsEdit(false)
    }
  }, [budgets_percentage])

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false)
      setCeremony(null)
    } else {
      setModal(true)
    }
  }, [modal]);

  const handleUserClick = useCallback((arg) => {
    const ceremony_pack = arg

    setSelectedCeremonyType({label:ceremony_pack.ceremony_name,value:ceremony_pack.ceremony_id})
    setSelectedVendorType({
      label: ceremony_pack.vendor_cat_name,
      value: ceremony_pack.vendor_cat_id,
    })
    setCeremony({
      id: ceremony_pack.id,
      budget_percentage: ceremony_pack.budget_percentage,
      is_active: ceremony_pack.is_active,
    })
    setIsEdit(true)
    toggle()
  }, [toggle])

  //delete ceremony_pack
  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = ceremony_pack => {
    setCeremony(ceremony_pack)
    setDeleteModal(true)
  }

  const handleDeleteUser = () => {
    if (ceremony_pack.id) {
      dispatch(deleteBudget_percentage(ceremony_pack))
      // setDeleteModal(false)
    }
  }
  useEffect(() => {
    if(!loading){
      setDeleteModal(false)
           setModal(false) 
    } 

  },[loading])
  const handleUserClicks = () => {
    setIsEdit(false)
    toggle()
  }
  const columns = useMemo(
    () => [
      // {
      //   Header: "Id",
      //   accessor: "checkbox",
      //   disableFilters: true,
      //   filterable: false,
      //   Cell: cellProps => {
      //     return <input type="checkbox" className="selection-input-4" />
      //   },
      // },
      {
        Header: "ceremony type",
        accessor: "ceremony_name",
        filterable: true,
        Cell: cellProps => {
          return <CeremonyType {...cellProps} />
        },
      },
      {
        Header: "Vendor type",
        accessor: "vendor_cat_name",
        filterable: true,

        Cell: cellProps => {
          return <VendorType {...cellProps} />
        },
      },
      {
        Header: "Budget percentage",
        accessor: "budget_percentage",
        filterable: true,

        Cell: cellProps => {
          return <Percentage {...cellProps} />
        },
      },
      {
        Header: "Active",
        accessor: "is_active",
        filterable: true,
        disableFilters: true,

        Cell: cellProps => (
          <div className="form-check form-switch form-switch-lg">
            {cellProps.value === 1 ? (
              <input
                disabled={loading}
                onClick={e =>
                  dispatch(
                    updateBudget_percentage({
                      is_active: 0,
                      id: cellProps.row.original.id,
                    })
                  )
                }
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizelg"
                checked={true}
              />
            ) : (
              <input
                disabled={loading}
                onClick={e =>
                  dispatch(
                    updateBudget_percentage({
                      is_active: 1,
                      id: cellProps.row.original.id,
                    })
                  )
                }
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizelg"
                checked={false}
              />
            )}
          </div>
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3 users">
              <ul className="list-inline font-size-20 contact-links mb-0">
                <li className="list-inline-item">
                  <Link
                    to="#"
                    className="text-primary"
                    onClick={() => {
                      const ceremonies = cellProps.row.original
                      handleUserClick(ceremonies)
                    }}
                  >
                    <i className="uil uil-pen font-size-18" id="edittooltip" />
                    <UncontrolledTooltip placement="top" target="edittooltip">
                      Edit
                    </UncontrolledTooltip>
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link
                    to="#"
                    className="text-danger"
                    onClick={() => {
                      const ceremonies = cellProps.row.original
                      onClickDelete(ceremonies)
                    }}
                  >
                    <i
                      className="uil uil-trash-alt font-size-18"
                      id="deletetooltip"
                    />
                    <UncontrolledTooltip placement="top" target="deletetooltip">
                      Delete
                    </UncontrolledTooltip>
                  </Link>
                </li>
                {/* <li className="list-inline-item dropdown">
                  <UncontrolledDropdown>
                    <DropdownToggle
                      tag="a"
                      className="text-muted font-size-18 px-2"
                      caret
                    >
                      <i className="uil uil-ellipsis-v"></i>
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-end">
                      <DropdownItem href="#">Action</DropdownItem>
                      <DropdownItem href="#">Another action</DropdownItem>
                      <DropdownItem href="#">Something else here</DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </li> */}
              </ul>
            </div>
          )
        },
      },
    ],
    [handleUserClick, loading,budgets_percentage]
  )

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
        loading={loading}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="MENU" breadcrumbItem="Budget percentage" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainerBudget
                    columns={columns}
                    data={budgets_percentage}
                    isGlobalFilter={true}
                    isAddUsers={true}
                    isAddTableWithoutBorderStrap={true}
                    handleUserClicks={handleUserClicks}
                    setPage={setOffset}
                    page_number={offset}
                    total_pages={total_page}
                    setPageSize={setPageSize}
                    page_size={page_size}
                    onBlur={(data)=>dispatch(updateBudget_percentage(data))}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "Edit User" : "Add Users"}
            </ModalHeader>
            <ModalBody>
              <Form
                onSubmit={e => {
                  e.preventDefault()
                  validation.handleSubmit()
                  return false
                }}
              >
                <Row>
                  <Col className="col-12">
                    <div className="mb-3">
                      <Label className="form-label">Ceremony type</Label>
                      <div className="mb-3">
                        <Select
                          value={selectedCeremony_type}
                          onChange={option => {
                            handleSelect(option)
                          }}
                          options={ceremonies_typeOptions}
                          classNamePrefix="select2-selection"
                        />
                      </div>
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Vendor type</Label>
                      <div className="mb-3">
                        <Select
                          value={selectedVendor_type}
                          onChange={option => {
                            setSelectedVendorType(option)
                          }}
                          options={vendors_typeOptions}
                          classNamePrefix="select2-selection"
                        />
                      </div>
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Budget percentage</Label>
                      <Input
                        name="budget_percentage"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.budget_percentage || ""}
                        invalid={
                          validation.touched.budget_percentage &&
                          validation.errors.budget_percentage
                            ? true
                            : false
                        }
                      />
                      {validation.touched.budget_percentage &&
                      validation.errors.budget_percentage ? (
                        <FormFeedback type="invalid">
                          {validation.errors.budget_percentage}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      {validation.values.is_active === 1 ? (
                        <input
                          type="checkbox"
                          className="selection-input-4 m-1"
                          defaultChecked
                          onClick={() => (validation.values.is_active = 0)}
                        />
                      ) : (
                        <input
                          type="checkbox"
                          className="selection-input-4 m-1"
                          onClick={() => (validation.values.is_active = 1)}
                        />
                      )}
                      <Label className="form-label">Active</Label>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="text-end">
                      {loading ? (
                        <Spinner
                          type="grow"
                          className="m-1 center"
                          color="primary"
                        />
                      ) : (
                        <button
                          type="submit"
                          className="btn btn-success save-user"
                        >
                          Save
                        </button>
                      )}
                    </div>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  )
}
Budget_percentage.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default Budget_percentage
